import React from "react";
import Layout from "../layouts/Layout";
import Logo from "../assets/logo.svg";
import Button from "../components/common/Button";
import FormInput from "../components/common/FormInput";
import FormSelect from "../components/common/FormSelect";
import {
  CourseSmallImage,
  CVC,
  MASTER,
  PAYPAL,
  PKFlag,
  USAFlag,
  VISA,
} from "../components/Icons";
import { Plus } from "lucide-react";
import Footer from "../components/Footer";

const CampsRegistration = () => {
  return (
    <>
      <div className="grid grid-cols-2">
        <div className="bg-[#FF66361A]">
          <div className="max-w-[726px] pl-24 pt-[34px]">
            <img src={Logo} alt="Steam Minds logo" className="w-[67px]" />

            <p className="mt-[70px] leading-5 text-black">Choose a currency</p>
            <div className="mt-6 flex  gap-2.5">
              <Button
                btnText="PKR 43,875.76"
                btnClassName="border border-black leading-5 py-[10px] gap-2.5 px-3"
                icon={PKFlag}
              />
              <Button
                btnText="PKR 43,875.76"
                btnClassName="border border-[#DED9DF] leading-5 py-[11px] gap-2.5 px-3"
                icon={USAFlag}
              />
            </div>

            <p className="mt-[90px] leading-5 text-[#938A96]">
              1 USD = 294.4675 PKR
            </p>

            <div className="mt-3 flex items-start justify-between gap-4">
              <div>
                <div className="flex gap-2">
                  <CourseSmallImage />

                  <h3 className=" leading-5 max-w-60 text-black">
                    Scratch Explorer: Foundations of Coding ( Online Coding
                    Camp)
                  </h3>
                </div>
                <p className="mt-[18px] leading-5 max-w-[317px]  text-[#938A96]">
                  Designed to enhance problem-solving with animation and game
                  creation.
                </p>
              </div>
              <p className="leading-5 text-black">PKR 43,875.66</p>
            </div>

            <div className="mt-10 h-px w-full bg-[#938A96]" />

            <div className="mt-8 leading-5  text-black">
              <p className="">Subtotal</p>

              <div className="mt-5 flex items-center justify-between">
                <p className="bg-[#D9D9D9] py-2.5 px-[36px] rounded-[10px]">
                  SUMMER50
                </p>
                <p className="text-[#938A96]">-PKR 21,912.6</p>
              </div>
              <p className="mt-2 text-[#938A96]">50% Off</p>

              <div className="mt-5 flex justify-between">
                <p>Total due</p>
                <p>PKR 43,875.66</p>
              </div>
            </div>

            <div className="mt-[30px] mb-11 border border-[#938A96] px-[30px] py-5">
              <div className="flex gap-2">
                <CourseSmallImage />

                <h4 className=" leading-5 max-w-60 text-black">
                  Scratch Explorer: Foundations of Coding ( Online Coding Camp)
                </h4>
              </div>
              <p className="mt-4  text-[#938A96] leading-5 max-w-[317px]">
                Designed to enhance problem-solving with animation and game
                creation.
              </p>
            </div>
            <Button
              icon={Plus}
              btnText={"Add to your Order"}
              btnClassName={
                "bg-[#D9D9D9] gap-2.5 rounded-[10px] px-[14px] py-2.5 text-black leading-5"
              }
            />
          </div>
        </div>

        <div className=" bg-[#F5F5F566]  shadow-[-4px_0px_6px_-2px_#00000040] pt-24 pb-[68px] pl-12">
          <form className="w-full max-w-[816px]">
            <div className="flex flex-col gap-y-8">
              <FormInput
                id="email"
                label="Email"
                type="email"
                placeholder="email@example.com"
                inputClassName="mt-[15px] border border-[#938A96]"
              />

              <FormSelect
                id="timezone"
                label="Select Timezone"
                placeholder=""
                options={[
                  { label: "Asia/Karachi", value: "asia-karachi" },
                  { label: "Asia/Dubai", value: "asia-dubai" },
                  { label: "America/New_York", value: "america-new-york" },
                ]}
                selectClassName="text-lg"
              />

              <FormSelect
                id="batch-date"
                label="Select the Batch Date"
                placeholder=""
                options={[
                  { label: "10 Jun 2026", value: "jun-10" },
                  { label: "17 Jun 2026", value: "jun-17" },
                  { label: "24 Jun 2026", value: "jun-24" },
                ]}
                selectClassName="text-sm"
              />

              <FormSelect
                id="batch-time"
                label="Select the Batch Time"
                placeholder=""
                options={[
                  { label: "Morning (10:00 AM)", value: "morning" },
                  { label: "Afternoon (2:00 PM)", value: "afternoon" },
                  { label: "Evening (6:00 PM)", value: "evening" },
                ]}
                selectClassName="text-sm"
              />
            </div>
            <h2 className="mt-9 mb-[30px] text-2xl font-bold leading-7 text-black">
              Payment Method
            </h2>

            <FormInput
              id="cardInfo"
              type="text"
              placeholder="Card Information"
              label="Card Information"
              inputClassName="mt-[15px] border border-[#938A96]"
              rightContent={[<VISA />, <MASTER />, <PAYPAL />]}
            />

            <div className=" grid grid-cols-2">
              <FormInput id="expiry" type="text" placeholder="MM/YY"  inputClassName="border border-[#938A96]"/>
              <FormInput
                id="cvc"
                type="text"
                placeholder="CVC"
                rightContent={[<CVC />]}
                inputClassName="border border-[#938A96]"
              />
            </div>

            <FormInput
              id="holdername"
              className="mt-9"
              inputClassName="mt-[15px] border border-[#938A96]"
              label="Card Holder Name"
              type="text"
              placeholder="Full Name on Card"
              
            />

            <FormSelect
              id="country"
              label="Country or Region"
              className="mt-10"
              defaultValue="pakistan"
              placeholder=""
              options={[
                { label: "Pakistan", value: "pakistan" },
                { label: "United Arab Emirates", value: "uae" },
                { label: "United States", value: "usa" },
              ]}
              selectClassName="text-sm"
            />

            <label className="mt-10 leading-5 flex items-center py-11 gap-3 rounded-lg border border-[#938A96] px-2.5">
              <input
                type="checkbox"
                className=" h-5 w-5 border border-[#938A96]"
              />
              <span>
                Save my information for Faster Checkout
                <br />
                <span className=" text-[#938A96]">
                  Pay Securely at STEAM Minds. and everywhere link is accepted
                </span>
              </span>
            </label>

            <Button
              btnText={"Book"}
              btnClassName={
                "mt-16 w-full rounded-lg bg-[#FF6636] text-xl font-medium leading-5 text-white py-[14.5px]"
              }
            />
          </form>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default CampsRegistration;
